import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'camelCase',
})
export class CamelCasePipe implements PipeTransform {
  transform(value: string) {
    if (value === 'candidateName') return 'Interviewee';

    // Replace camelcase string into the array of words
    let separateWords: string[] | string = value
      .replace(/([a-zA-Z])(?=[A-Z])/g, '$1 ')
      .toLowerCase()
      .split(' ');

    if (value === 'oneToOneTopics') return 'Topic';

    if (value === 'os') return 'OS';

    if (value === 'SalaryStavka' || value === 'salaryStavka') return 'Stavka $';

    if (value === '_168') return '168';

    if (value === 'dataStampUTC') return 'Change date UTC';

    if (value === 'nda') return 'NDA';

    if (value === 'increasePercents') return 'Increase %';

    if (value === 'USDIBAN') return 'USD IBAN';

    if (value === 'SWIFTCode') return 'SWIFT Code';

    if (value === 'UAHIBAN') return 'UAH IBAN';

    if (value === 'pm') return 'PM';

    if (value === 'totalUSD') return 'Total USD';

    if (value === 'extraBonusUSD') return 'Extra bonus USD';

    for (let i = 0; i < separateWords.length; i++) {
      // if the word is sum replace it with upper case
      if (separateWords[i] === 'sum') {
        separateWords[i] = 'SUM';
      }
      // if the word is usd replace it with upper case
      if (separateWords[i] === 'usd') {
        separateWords[i] = 'USD';
      }
      // if the word is uah replace it with upper case
      if (separateWords[i] === 'uah') {
        separateWords[i] = 'UAH';
      }

      if (separateWords[i] === 'p' && separateWords[i + 1] === 'e') {
        separateWords[i] = 'PE';
        separateWords.splice(i + 1, 1);
      }

      // if the word is p (don't know exact name for percent from backend) please it with percent symbol
      if (separateWords[i] === 'p' && value !== 'PMId') {
        separateWords[i] = '%';
      }
      // if the word is day and the next is offs, connect them into one and delete offs from the array
      if (separateWords[i] === 'day' && separateWords[i + 1] === 'offs') {
        separateWords[i] = `${separateWords[i]}-${separateWords[i + 1]}`;
        separateWords.splice(i + 1, 1);
      }

      if (separateWords[i] === 'u' && separateWords[i + 1] === 'a') {
        separateWords[i] = 'UA';
        separateWords.splice(i + 1, 1);
      }
      if (separateWords[i] === 's' && separateWords[i + 1] === 't') {
        separateWords[i] = 'St';
        separateWords.splice(i + 1, 1);
      }
      if (
        separateWords[i] === 's' &&
        separateWords[i + 1] === 's' &&
        separateWords[i + 2] === 't'
      ) {
        separateWords[i] = 'Sst';
        separateWords.splice(i + 1, 2);
      }

      if (separateWords[i] === 'hr') {
        separateWords[i] = 'HR';
      }

      if (separateWords[i] === 'percents' || separateWords[i] === 'percent') {
        separateWords[i] = '%';
      }
    }
    // join an array into one string
    separateWords = separateWords.join(' ');
    // capitalize the first letter of the sentence
    const separateWordsCapital =
      separateWords[0]?.toUpperCase() + separateWords.substring(1);

    return separateWordsCapital;
  }
}
